import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import emailjs from "emailjs-com";
import { toast } from "react-hot-toast";

const ContactForm = () => {
  const contentRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const scrollToSection = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };
    scrollToSection();
  }, [location]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailParams = {
      email: formData.email,
      name: formData.name,
      message: formData.message,
      subject: `New contact form submission from ${formData.name}`,
    };

    sendEmail(emailParams);
  };

  const sendEmail = (emailParams) => {
    emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, 
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        emailParams,
        process.env.REACT_APP_EMAILJS_USER_ID 
      )
      .then(
        (response) => {
          toast.dismiss();
          toast.success("Email sent successfully!");
        },
        (error) => {
          toast.dismiss();
          toast.error(`Error: ${error.text}`); // Show error toast
        }
      );
  };

  return (
    <section
      id="contact"
      ref={contentRef}
      className="flex items-center justify-center h-fit-content bg-gradient-to-r from-green-700 to-green-900"
    >
      <div className="relative mt-20 mb-20 w-full lg:max-w-[85%] mx-auto bg-white bg-opacity-50 shadow-[0_0px_7px_rgba(0,0,0,0.7)] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/img/lepenec_bg8.png')" }}
        ></div>
        <div className="relative p-8 px-14 bg-white bg-opacity-50 lg:bg-opacity-80 lg:w-[60%] w-full clip-path-diagonal-right rounded-sm">
          <h2 className="text-4xl font-bold text-green-900 mb-4">
            {t("ContactForm.contacttitle")}
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full lg:w-3/4 mt-1 p-2 bg-white bg-opacity-80 border-2 border-green-900 rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 placeholder-gray-800"
                placeholder={t("ContactForm.namefield")}
                required
              />
            </div>
            <div>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full lg:w-3/4 mt-1 p-2 bg-white bg-opacity-80 border-2 border-green-900 rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 placeholder-gray-800"
                placeholder={t("ContactForm.emailfield")}
                required
              />
            </div>
            <div className="relative w-full lg:w-3/4">
              <textarea
                id="message"
                rows="8"
                value={formData.message}
                onChange={handleChange}
                className="w-full mt-1 p-2 pr-12 bg-white bg-opacity-80 border-2 border-green-900 rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 placeholder-gray-800"
                placeholder={t("ContactForm.messagefield")}
                required
              ></textarea>
            </div>

            <Button
              type="submit"
              className=""
              bgColor="bg-green-900"
              textColor="text-white"
              boxShadowColor="#15803d"
            >
              {t("ContactForm.sendbutton")}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
